const apiScope = process.env.REACT_APP_API_SCOPE;

export const loginRequest = {
  scopes: apiScope ? [apiScope] : ['User.Read']
};

export function getMsalConfig() {
  return {
    auth: {
      clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
      authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
      redirectUri: process.env.REACT_APP_REDIRECT_URI || '/'
    }
  };
}
